import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../components/layouts/dashboard'
import { useSelector } from 'react-redux'
import moment from 'moment'
import {
  useGetEmployee,
  useUpdateEmployeeProfile,
} from '../../redux/employee/hook'
import { Initials, formValidation } from '../../utils/functions'
import LoadingBar from '../../components/loader-bar'
import EmptyTableSVG from '../../assets/svg/empty-table.svg'
import Button from '../../components/button'
import ChangePassword from '../../components/modal/settings/change-password'
import EnableTwoFactorAuthentication from '../../components/modal/settings/enable-2fa'
import { updateUser, useDisable2Fa } from '../../redux/user/hook'
import FormSwitch from '../../components/form-switch'
import { useForm } from 'react-hook-form'
import FormInput from '../../components/form-input'
import DOMPurify from 'dompurify'
import FormSelect from '../../components/form-select'
import { employees } from '../../api'
import {
  useGetBanks,
  useGetPFA,
  useResolveBankAccount,
} from '../../redux/bank/hook'
import FormDatalist from '../../components/form-datalist'

const ProfilePage = () => {
  useEffect(() => {
    updateUser({ reload: false })
    window.scroll(0, 0)
  }, [])

  const {
    register,
    handleSubmit,
    formState: { isValid },
    errors,
  } = useForm({
    mode: 'onChange',
  })

  const { user } = useSelector((state) => state.userSlice)
  const { company } = useSelector((state) => state.companySlice)
  const [pfa_name, setPFAName] = useState('')
  const { data: PFAs } = useGetPFA()

  const { mutateAsync: disableTwoFa, isLoading: disableTwoFaLoading } =
    useDisable2Fa()

  const [showChangePassword, setShowChangePassword] = useState(null)
  const [showEnable2Fa, setShowEnable2Fa] = useState(null)
  const [editMode, setEditMode] = useState(false)
  const [bankname, setBankName] = useState('')
  const [account_number, setAccountNumber] = useState('')
  const [account_name, setAccountName] = useState('')

  const { data: employeeData, isLoading: employeeDataLoading } =
    useGetEmployee()

  const { mutateAsync: updateEmployee, isLoading: loading } =
    useUpdateEmployeeProfile()
  const { data: banks, isLoading } = useGetBanks()

  const { mutateAsync: resolveAccount, isLoading: resolveAccountLoading } =
    useResolveBankAccount()

  const [maritalStatus, setMaritalStatus] = useState('single')
  const maritalOptions = [
    { value: 'single', label: 'Single' },
    { value: 'married', label: 'Married' },
  ]

  console.log(employeeData, 'employeeData')

  useEffect(() => {
    if (account_number?.length >= 10 && bankname !== '') {
      let payload = {
        bankname,
        account_number,
      }
      setAccountName('')
      resolveAccount(payload).then((response) => {
        setAccountName(response.data.accountname)
      })
    }
  }, [account_number, bankname])

  useEffect(() => {
    if (employeeData) {
      setMaritalStatus(employeeData.marital_status)
      setBankName(employeeData.bank)
      setAccountNumber(employeeData.account_number)
      setAccountName(employeeData.account_name)
      setPFAName(employeeData?.pfa_name)
    }
  }, [employeeData])

  // 'email' => 'required',
  //               'mobile' => 'required',
  //               'country' => 'required',
  //               'state' => 'required',
  //               'city' => 'required',
  //               'address' => 'required',
  //               'martial_status' => 'required',

  //               'bank_name' => 'required',
  //               'account_name' => 'required',
  //               'account_number' => 'required',

  function submit(data) {
    const email = DOMPurify.sanitize(data?.email)
    const mobile = DOMPurify.sanitize(data?.mobile)
    const tax_number = DOMPurify.sanitize(data?.tax_number)
    const employee_voluntary_pension = DOMPurify.sanitize(
      data?.employee_voluntary_pension
    )

    const rsa_pin = DOMPurify.sanitize(data?.rsa_pin)
    const country = DOMPurify.sanitize(data?.country)
    const state = DOMPurify.sanitize(data?.state)
    const city = DOMPurify.sanitize(data?.city)
    const address = DOMPurify.sanitize(data?.address)
    // const dob = DOMPurify.sanitize(data?.dob)
    const next_of_kin_name = DOMPurify.sanitize(data?.next_of_kin_name)
    const next_of_kin_mobile = DOMPurify.sanitize(data?.next_of_kin_mobile)
    const next_of_kin_email = DOMPurify.sanitize(data?.next_of_kin_email)
    const next_of_kin_relationship = DOMPurify.sanitize(
      data?.next_of_kin_relationship
    )
    const next_of_kin_address = DOMPurify.sanitize(data?.next_of_kin_address)

    let payload = {
      mobile,
      email,
      tax_number,
      employee_voluntary_pension,
      rsa_pin,
      pfa_name: pfa_name,
      country,
      state,
      city,
      address,
      // dob,
      next_of_kin_name,
      next_of_kin_mobile,
      next_of_kin_email,
      next_of_kin_relationship,
      next_of_kin_address,
      bank: bankname,
      account_name: account_name,
      account_number: account_number,
      martial_status: maritalStatus,
    }

    updateEmployee(payload).then((result) => {
      setEditMode(false)
    })
  }

  return (
    <DashboardLayout title='My Profile'>
      <div className='flex flex-col'>
        {showChangePassword ? (
          <ChangePassword
            isOpen={showChangePassword}
            closeModal={() => setShowChangePassword(false)}
          />
        ) : null}
        {showEnable2Fa ? (
          <EnableTwoFactorAuthentication
            isOpen={showEnable2Fa}
            closeModal={() => setShowEnable2Fa(false)}
          />
        ) : null}
        <div className='flex flex-col bg-white shadow-md rounded-md'>
          <div className='flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3'>
            <div className='p3-bold header-4'>My Profile</div>
            <div className='flex flex-col md:flex-row items-center gap-[10px] md:items-center justify-center'>
              <div className='md:w-fit w-[100%]'>
                <Button
                  text='Change Password'
                  type='button'
                  theme='primary'
                  className='flex gap-2 !h-[40px] w-fit p-2 '
                  textClass={'!text-[12px]'}
                  onClick={() => {
                    setShowChangePassword(true)
                  }}
                />
              </div>
              {user.enable_two_fa === 1 ? (
                <div className='md:w-fit w-[100%]'>
                  <Button
                    text='DISABLE TWO-FACTOR AUTHENTICATION'
                    type='button'
                    theme='primary'
                    className='flex gap-2 h-[40px] w-fit p-2 !bg-red-700'
                    textClass={'!text-[12px]'}
                    loading={disableTwoFaLoading}
                    onClick={() => {
                      disableTwoFa()
                    }}
                  />
                </div>
              ) : (
                <div className='md:w-fit w-[100%]'>
                  <Button
                    text='ENABLE TWO-FACTOR AUTHENTICATION'
                    type='button'
                    theme='secondary'
                    className='flex gap-2 h-[40px] w-fit p-2'
                    textClass={'!text-[12px]'}
                    onClick={() => {
                      setShowEnable2Fa(true)
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          <hr className='divider mt-2 -mb-2' />
          {user?.company_id ? (
            <div className='p-4'>
              {employeeDataLoading ? (
                <LoadingBar loading={employeeDataLoading} />
              ) : (
                <>
                  {employeeData ? (
                    <div className='flex flex-col gap-2'>
                      <div className='w-[200px] mt-2 !font-semibold'>
                        <FormSwitch
                          label={'Edit Mode'}
                          name={'switch-edit-mode'}
                          checked={editMode}
                          onClick={() => setEditMode(!editMode)}
                          value={editMode}
                        />
                      </div>
                      {editMode ? (
                        <form
                          className='form border p-4 rounded-md w-full'
                          onSubmit={handleSubmit(submit)}
                        >
                          <div className='grid grid-cols-1 md:grid-cols-3 gap-4 w-full'>
                            <div className='w-full'>
                              <FormInput
                                label='Email'
                                name='email'
                                type='text'
                                className='!bg-white'
                                defaultValue={employeeData?.email}
                                inputRef={register(
                                  formValidation('text', true)
                                )}
                                readOnly={loading}
                                error={errors.email}
                                errorMessage={
                                  errors.email && errors.email.message
                                }
                              />
                            </div>
                            <div className='w-full'>
                              <FormInput
                                label='Phone Number'
                                name='mobile'
                                type='text'
                                className='!bg-white'
                                defaultValue={employeeData?.mobile}
                                inputRef={register(
                                  formValidation('text', true)
                                )}
                                readOnly={loading}
                                error={errors.mobile}
                                errorMessage={
                                  errors.mobile && errors.mobile.message
                                }
                              />
                            </div>
                            <div className='w-full'>
                              <FormInput
                                label='Country'
                                name='country'
                                type='text'
                                className='!bg-white'
                                defaultValue={employeeData?.country}
                                inputRef={register(
                                  formValidation('text', true)
                                )}
                                readOnly={loading}
                                error={errors.country}
                                errorMessage={
                                  errors.country && errors.country.message
                                }
                              />
                            </div>
                            <div className='w-full'>
                              <FormInput
                                label='State'
                                name='state'
                                type='text'
                                className='!bg-white'
                                defaultValue={employeeData?.state}
                                inputRef={register(
                                  formValidation('text', false)
                                )}
                                readOnly={loading}
                                error={errors.state}
                                errorMessage={
                                  errors.state && errors.state.message
                                }
                              />
                            </div>
                            <div className='w-full'>
                              <FormInput
                                label='City'
                                name='city'
                                type='text'
                                className='!bg-white'
                                defaultValue={employeeData?.city}
                                inputRef={register(
                                  formValidation('text', true)
                                )}
                                readOnly={loading}
                                error={errors.city}
                                errorMessage={
                                  errors.city && errors.city.message
                                }
                              />
                            </div>

                            {/* <div className='w-full'>
                              <FormInput
                                label='Date Of Birth'
                                name='dob'
                                type='date'
                                className='!bg-white'
                                defaultValue={employeeData?.dob}
                                inputRef={register(
                                  formValidation('text', false)
                                )}
                                readOnly={loading}
                                error={errors.dob}
                                errorMessage={errors.dob && errors.dob.message}
                              />
                            </div> */}

                            <div className='w-full'>
                              <FormInput
                                label='Address'
                                name='address'
                                type='text'
                                className='!bg-white'
                                defaultValue={user?.address}
                                inputRef={register(
                                  formValidation('text', true)
                                )}
                                readOnly={loading}
                                error={errors.address}
                                errorMessage={
                                  errors.address && errors.address.message
                                }
                              />
                            </div>
                            <div className='w-full'>
                              <FormSelect
                                defaultValue={maritalStatus}
                                options={maritalOptions}
                                onChange={(selected) =>
                                  setMaritalStatus(selected)
                                }
                                extraClass='!bg-white'
                                label='Marital Status'
                              />
                            </div>
                            <div className='w-full'>
                              <FormDatalist
                                label='Bank Name'
                                data={banks ? banks : []}
                                value={bankname}
                                onSelect={(value) => {
                                  setAccountNumber('')
                                  setBankName(value)
                                }}
                              />
                            </div>
                            <div className='w-full'>
                              <FormInput
                                label='Account Number'
                                name='account_number'
                                placeholder={'Enter an account number'}
                                type='text'
                                value={account_number}
                                error={errors.account_number}
                                errorMessage={
                                  errors.account_number &&
                                  errors.account_number.message
                                }
                                className={'!bg-white'}
                                onInput={(e) =>
                                  setAccountNumber(e.target.value)
                                }
                              />
                            </div>
                            <div className='w-full'>
                              <FormInput
                                label='Account Name'
                                name='account_name'
                                type='text'
                                placeholder={
                                  resolveAccountLoading
                                    ? 'Fetching Account Name ....'
                                    : 'Auto generated'
                                }
                                readOnly
                                inputRef={register(
                                  formValidation('text', true)
                                )}
                                value={account_name}
                                error={errors.account_name}
                                className={'!bg-white'}
                                errorMessage={
                                  errors.account_name &&
                                  errors.account_name.message
                                }
                              />
                            </div>

                            <div className='w-full'>
                              <FormInput
                                label='Tax ID'
                                name='tax_number'
                                type='text'
                                className='!bg-white'
                                defaultValue={employeeData?.tax_number}
                                inputRef={register(
                                  formValidation('text', false)
                                )}
                                readOnly={loading}
                                error={errors.tax_number}
                                errorMessage={
                                  errors.tax_number && errors.tax_number.message
                                }
                              />
                            </div>
                            <div className='w-full'>
                              <FormInput
                                label='Employee Voluntary Pension'
                                name='employee_voluntary_pension'
                                type='text'
                                className='!bg-white'
                                defaultValue={
                                  company?.compensation
                                    ?.employee_voluntary_pension
                                }
                                inputRef={register(
                                  formValidation('text', false)
                                )}
                                readOnly={loading}
                                error={errors.employee_voluntary_pension}
                                errorMessage={
                                  errors.employee_voluntary_pension &&
                                  errors.employee_voluntary_pension.message
                                }
                              />
                            </div>
                            <div className='w-full'>
                              <FormInput
                                label='Pension RSA Pin'
                                name='rsa_pin'
                                type='text'
                                className='!bg-white'
                                defaultValue={employeeData?.rsa_pin}
                                inputRef={register(
                                  formValidation('text', false)
                                )}
                                readOnly={loading}
                                error={errors.rsa_pin}
                                errorMessage={
                                  errors.rsa_pin && errors.rsa_pin.message
                                }
                              />
                            </div>
                            <div className='w-full'>
                              <FormSelect
                                value={pfa_name}
                                options={PFAs}
                                onChange={(selected) => setPFAName(selected)}
                                extraClass='!bg-white'
                                label='Pension Fund Administrator (PFA)'
                              />
                            </div>
                            <div className='w-full'>
                              <FormInput
                                label='Next of kin name'
                                name='next_of_kin_name'
                                type='text'
                                className='!bg-white'
                                defaultValue={employeeData?.next_of_kin_name}
                                inputRef={register(
                                  formValidation('text', false)
                                )}
                                readOnly={loading}
                                error={errors.next_of_kin_name}
                                errorMessage={
                                  errors.next_of_kin_name &&
                                  errors.next_of_kin_name.message
                                }
                              />
                            </div>
                            <div className='w-full'>
                              <FormInput
                                label='Next of kin mobile'
                                name='next_of_kin_mobile'
                                type='text'
                                className='!bg-white'
                                defaultValue={employeeData?.next_of_kin_mobile}
                                inputRef={register(
                                  formValidation('text', false)
                                )}
                                readOnly={loading}
                                error={errors.next_of_kin_mobile}
                                errorMessage={
                                  errors.next_of_kin_mobile &&
                                  errors.next_of_kin_mobile.message
                                }
                              />
                            </div>
                            <div className='w-full'>
                              <FormInput
                                label='Next of kin email'
                                name='next_of_kin_email'
                                type='text'
                                className='!bg-white'
                                defaultValue={employeeData?.next_of_kin_email}
                                inputRef={register(
                                  formValidation('text', false)
                                )}
                                readOnly={loading}
                                error={errors.next_of_kin_email}
                                errorMessage={
                                  errors.next_of_kin_email &&
                                  errors.next_of_kin_email.message
                                }
                              />
                            </div>
                            <div className='w-full'>
                              <FormInput
                                label='Next of kin relationship'
                                name='next_of_kin_relationship'
                                type='text'
                                className='!bg-white'
                                defaultValue={
                                  employeeData?.next_of_kin_relationship
                                }
                                inputRef={register(
                                  formValidation('text', false)
                                )}
                                readOnly={loading}
                                error={errors.next_of_kin_relationship}
                                errorMessage={
                                  errors.next_of_kin_relationship &&
                                  errors.next_of_kin_relationship.message
                                }
                              />
                            </div>
                            <div className='w-full'>
                              <FormInput
                                label='Next of kin address'
                                name='next_of_kin_address'
                                type='text'
                                className='!bg-white'
                                defaultValue={employeeData?.next_of_kin_address}
                                inputRef={register(
                                  formValidation('text', false)
                                )}
                                readOnly={loading}
                                error={errors.next_of_kin_address}
                                errorMessage={
                                  errors.next_of_kin_address &&
                                  errors.next_of_kin_address.message
                                }
                              />
                            </div>
                          </div>
                          <div className='flex w-[100px] ml-auto justify-end '>
                            <Button
                              text='Update'
                              type='submit'
                              loading={loading}
                              disabled={loading}
                              className='!h-[40px] w-fit px-4'
                              textClass='text-sm'
                            />
                          </div>
                        </form>
                      ) : (
                        <>
                          <div className='flex flex-row items-center gap-3'>
                            <div className='text-[25px] flex justify-center items-center h-[60px] w-[60px] border-[3px] header-3 rounded-[60px] relative hover:scale-110 hover:m-2 hover:opacity-25 duration-500 text-black font-bold'>
                              {employeeData?.logo ? (
                                <div>
                                  <img
                                    src={employeeData?.logo}
                                    alt='email_icon'
                                    className='object-fit min-w-[52px] min-h-[52px] max-w-[52px] max-h-[52px]'
                                  />
                                </div>
                              ) : (
                                <span className='text-black font-bold text-[25px]'>
                                  {Initials(employeeData?.company_name)}
                                </span>
                              )}
                            </div>

                            <button className='lg:flex header-4 header-3 text-[25px] text-black'>
                              {employeeData?.company_name}
                            </button>
                          </div>
                          <div className='flex flex-col mt-1 gap-4'>
                            <div className='flex flex-col lg:flex-row gap-4'>
                              <div className='flex flex-col p-3 border rounded-md shadow-md w-full'>
                                <span className='header-3 mb-3'>
                                  Personal Information
                                </span>
                                <div className='grid md:grid-cols-2  grid-cols-1 gap-4 w-full'>
                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      First Name
                                    </span>
                                    <span className='mt-1 text-sm text-color-black font-bold'>
                                      {employeeData?.first_name}
                                    </span>
                                  </div>
                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      Last name
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-bold'>
                                      {employeeData?.last_name}
                                    </span>
                                  </div>
                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      Phone Number
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-bold'>
                                      {employeeData?.mobile}
                                    </span>
                                  </div>

                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      Email
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-bold'>
                                      {employeeData?.email}
                                    </span>
                                  </div>
                                  {/* <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      Date of birth
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-bold'>
                                      {moment(employeeData?.dob).format(
                                        'MMMM DD, YYYY'
                                      )}
                                    </span>
                                  </div> */}
                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      Gender
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-bold'>
                                      {employeeData?.gender}
                                    </span>
                                  </div>
                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      Country
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-bold'>
                                      {employeeData?.country}
                                    </span>
                                  </div>
                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      State
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-bold'>
                                      {employeeData?.state}
                                    </span>
                                  </div>
                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      City
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-bold'>
                                      {employeeData?.city}
                                    </span>
                                  </div>
                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      Address
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-bold'>
                                      {user?.address}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className='flex flex-col p-3 border rounded-md shadow-md w-full'>
                                <span className='header-3 mb-3'>
                                  Employment information
                                </span>
                                {/* <hr className='divider mt-2' /> */}
                                <div className='flex flex-col'>
                                  <span className='text-sm font-semibold text-color-gray'>
                                    Staff Number
                                  </span>
                                  <span className='mt-1 text-color-black text-sm font-bold'>
                                    {employeeData?.staff_number}
                                  </span>
                                </div>
                                <div className='grid md:grid-cols-2  grid-cols-1 gap-4 w-full mt-3'>
                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      Date Of Employment
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-bold'>
                                      {moment(employeeData?.date_joined).format(
                                        'MMMM DD, YYYY'
                                      )}
                                    </span>
                                  </div>
                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      Job Position
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-bold'>
                                      {employeeData?.job_position
                                        ? employeeData?.job_position
                                        : 'Not Set'}
                                    </span>
                                  </div>
                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      Pension Fund Administrator
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-bold'>
                                      {employeeData?.pfa_name
                                        ? employeeData.pfa_name
                                        : 'Not Set'}
                                    </span>
                                  </div>
                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      Pension R.S.A PIN
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-bold'>
                                      {employeeData?.rsa_pin
                                        ? employeeData.rsa_pin
                                        : 'Not Set'}
                                    </span>
                                  </div>
                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      Tax ID
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-bold'>
                                      {employeeData?.tax_number
                                        ? employeeData.tax_number
                                        : 'Not Set'}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className='flex flex-col lg:flex-row gap-4'>
                              <div className='flex flex-col p-3 border rounded-md shadow-md w-full'>
                                <span className='header-3 mb-3'>
                                  Salary Payment information
                                </span>
                                {/* <hr className='divider mt-2' /> */}
                                <div className='grid md:grid-cols-2  grid-cols-1 gap-4 w-full'>
                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      Bank Name
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-bold'>
                                      {employeeData?.bank}
                                    </span>
                                  </div>
                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      Account Number
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-bold'>
                                      {employeeData?.account_number}
                                    </span>
                                  </div>
                                </div>
                                <div className='grid md:grid-cols-1  grid-cols-1 w-full mt-4'>
                                  <div className='flex flex-col'>
                                    <span className='text-sm font-semibold text-color-gray'>
                                      Account Name
                                    </span>
                                    <span className='mt-1 text-color-black text-sm font-semibold'>
                                      {employeeData?.account_name}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className='flex flex-col p-3 border rounded-md shadow-md w-full'>
                                <span className='header-3 mb-3'>
                                  Compensation
                                </span>
                                {company?.compensation ? (
                                  <div className='grid md:grid-cols-2  grid-cols-1 gap-4 w-full'>
                                    <div className='flex flex-col'>
                                      <span className='text-[13px] font-medium text-color-gray'>
                                        Basic Salary
                                      </span>
                                      <span className='mt-1 text-color-black text-sm font-semibold text-[14px]'>
                                        {company?.compensation?.basic_salary.toLocaleString(
                                          'en-NG',
                                          {
                                            style: 'currency',
                                            currency: 'NGN',
                                          }
                                        )}
                                      </span>
                                    </div>
                                    <div className='flex flex-col'>
                                      <span className='text-[13px] font-medium text-color-gray'>
                                        Housing Allowance
                                      </span>
                                      <span className='mt-1 text-color-black text-sm font-semibold text-[14px]'>
                                        {company?.compensation?.housing_allowance.toLocaleString(
                                          'en-NG',
                                          {
                                            style: 'currency',
                                            currency: 'NGN',
                                          }
                                        )}
                                      </span>
                                    </div>
                                    <div className='flex flex-col'>
                                      <span className='text-[13px] font-medium text-color-gray'>
                                        Transportation Allowance
                                      </span>
                                      <span className='mt-1 text-color-black text-sm font-semibold text-[14px]'>
                                        {company?.compensation?.transportation_allowance.toLocaleString(
                                          'en-NG',
                                          {
                                            style: 'currency',
                                            currency: 'NGN',
                                          }
                                        )}
                                      </span>
                                    </div>
                                    <div className='flex flex-col'>
                                      <span className='text-[13px] font-medium text-color-gray'>
                                        Other Allowances
                                      </span>
                                      <span className='mt-1 text-color-black text-sm font-semibold text-[14px]'>
                                        {company?.compensation?.other_allowance.toLocaleString(
                                          'en-NG',
                                          {
                                            style: 'currency',
                                            currency: 'NGN',
                                          }
                                        )}
                                      </span>
                                    </div>
                                    <div className='flex flex-col'>
                                      <span className='text-[13px] font-medium text-color-gray'>
                                        Employee Voluntary Pension
                                      </span>
                                      <span className='mt-1 text-color-black text-sm font-semibold text-[14px]'>
                                        {company?.compensation?.employee_voluntary_pension.toLocaleString(
                                          'en-NG',
                                          {
                                            style: 'currency',
                                            currency: 'NGN',
                                          }
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                ) : (
                                  <div className='flex items-center justify-center font-semibold'>
                                    No compensation added yet
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  ) : (
                    <div className='flex items-center justify-center min-w-full mt-4'>
                      <img
                        src={EmptyTableSVG}
                        alt='No Data Fetched'
                        width={'40%'}
                        height={'400px'}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          ) : (
            <div className='p-4'>
              <div className='flex flex-col gap-4'>
                <div className='flex md:flex-row flex-col mt-1 gap-4'>
                  <div className='flex flex-col md:w-2/3 gap-4'>
                    <div className='flex flex-col p-3 border rounded-md shadow-md'>
                      <span className='header-4 mb-3 p-2 px-4 text-white rounded-[8px] bg-secondary-2 max-w-fit'>
                        Personal Information
                      </span>
                      <div className='grid md:grid-cols-2  grid-cols-1 gap-4 w-full'>
                        <div className='flex flex-col'>
                          <span className='text-sm font-semibold text-color-gray'>
                            First Name
                          </span>
                          <span className='mt-1 text-color-black text-sm font-bold'>
                            {user?.first_name}
                          </span>
                        </div>
                        <div className='flex flex-col'>
                          <span className='text-sm font-semibold text-color-gray'>
                            Last name
                          </span>
                          <span className='mt-1 text-color-black text-sm font-bold'>
                            {user?.last_name}
                          </span>
                        </div>
                        <div className='flex flex-col'>
                          <span className='text-sm font-semibold text-color-gray'>
                            Phone Number
                          </span>
                          <span className='mt-1 text-color-black text-sm font-bold'>
                            {user?.mobile}
                          </span>
                        </div>
                        <div className='flex flex-col'>
                          <span className='text-sm font-semibold text-color-gray'>
                            Email
                          </span>
                          <span className='mt-1 text-color-black text-sm font-bold'>
                            {user?.email}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  )
}

export default ProfilePage
